/**
 * PSTUDIO-4168: the one place that builds the store's solution-version identity
 * from XState context.
 *
 * The shape (`<customerId>-<botName>-<draftVersion>`) is load-bearing: it is the
 * value `tableStore.solutionVersionId` holds, what every queued write is stamped
 * with, what `solutionScopeOf` strips a version off, and what the cross-tab
 * broadcast is filtered by. It was already spelled out in two places
 * (`use-table-store-sync`, `builder`) and this ticket needed a third reader, so
 * it lives here instead — a drift between two copies of THIS string is a write
 * landing in the wrong solution.
 *
 * Returns `''` when any part is missing, which is the value the store uses for
 * "outside the builder" and which every write path already fails safe on.
 */
export function buildSolutionVersionId(parts: {
  customerId?: string | null;
  botName?: string | null;
  draftVersion?: string | null;
}): string {
  const { customerId, botName, draftVersion } = parts;
  if (!customerId || !botName || !draftVersion) {
    return '';
  }
  return `${customerId}-${botName}-${draftVersion}`;
}
